function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ExploreTemplate = require('./explore.template');
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var ViewPost = require('../view-post');
var SaitoUser = require('../../../../../lib/saito/ui/saito-user/saito-user');
var PostTeaser = require('../post-teaser');
var ExploreOverlay = /*#__PURE__*/function () {
  function ExploreOverlay(app, mod) {
    _classCallCheck(this, ExploreOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod);
    this.posts = {};
    this.lastTimeStamp = {};
    this.isLoading = true;
    this.awaitingPeers = false;
    this.subscriptions = [];
    this.targetPublicKey = null; // For URL-based routing: publicKey to show posts for
  }
  return _createClass(ExploreOverlay, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        var html;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              // ========================================================================
              // INVARIANT 4: Unmount before navigating to explore (navigation path: editor → explore)
              // ========================================================================
              if (this.mod.create_post_ui && typeof this.mod.create_post_ui.onEditorUnmount === 'function') {
                this.mod.create_post_ui.onEditorUnmount();
              }
              this.subscriptions = this.calculateSubscriptions();
              if (!this.targetPublicKey) {
                this.targetPublicKey = this.mod.STACK_OFFICIAL_PUBLICKEY;
              }
              html = ExploreTemplate(this.app, this.mod, this.subscriptions);
              this.overlay.show(html);
              setTimeout(function () {
                _this.attachEvents();
                _this.updateHelpNoteVisibility();
                // Load posts after attaching events (skip if URL-based routing already loaded posts)
                _this.loadPostsForFilter(_this.targetPublicKey);
              }, 25);
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "createLabel",
    value: function createLabel(publicKey) {
      if (publicKey == this.mod.STACK_OFFICIAL_PUBLICKEY) {
        return 'SaitoOfficial';
      }
      if (publicKey == this.mod.publicKey) {
        return 'My Posts';
      }
      return this.app.keychain.returnUsername(publicKey);
    }

    /**
     * Fixed labels (SaitoOfficial, My Posts) must not be rewritten by the
     * .saito-address registry lookup; every other creator label should be.
     */
  }, {
    key: "isAddressLabel",
    value: function isAddressLabel(publicKey) {
      return publicKey != this.mod.STACK_OFFICIAL_PUBLICKEY && publicKey != this.mod.publicKey;
    }

    //
    // Sidebar is SaitoOfficial, My Posts, then active subscriptions.
    // The creator currently open in the main pane is not listed unless they
    // are one of those.
    //
  }, {
    key: "calculateSubscriptions",
    value: function calculateSubscriptions() {
      var subscriptions = [{
        icon: 'fa-solid fa-user',
        label: 'SaitoOfficial',
        publickey: this.mod.STACK_OFFICIAL_PUBLICKEY,
        isAddress: false,
        source: 'default'
      }, {
        icon: 'fa-solid fa-user',
        label: 'My Posts',
        publickey: this.mod.publicKey,
        isAddress: false,
        source: 'default'
      }];
      var listed = new Set(subscriptions.map(function (entry) {
        return entry.publickey;
      }));
      var _iterator = _createForOfIteratorHelper(this.mod.getSubscriptions()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var pk = _step.value;
          if (!pk || listed.has(pk)) {
            continue;
          }
          listed.add(pk);
          subscriptions.push({
            publickey: pk,
            icon: 'fa-solid fa-user',
            label: this.createLabel(pk),
            isAddress: this.isAddressLabel(pk),
            source: 'subscription'
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return subscriptions;
    }
  }, {
    key: "updateHelpNoteVisibility",
    value: function updateHelpNoteVisibility() {
      // Count subscription items
      var subscriptionItems = document.querySelectorAll('.explore .filters > .item');
      var helpNote = document.querySelector('.explore .help');
      if (helpNote && subscriptionItems.length > 2) {
        // Hide help note if more than 2 subscriptions
        helpNote.classList.add('hide-help');
      } else if (helpNote) {
        // Show help note if 2 or fewer subscriptions
        helpNote.classList.remove('hide-help');
      }
    }
  }, {
    key: "updateAuthorHeader",
    value: function updateAuthorHeader() {
      var _this2 = this;
      var authorHeader = document.querySelector('#stack-explore-author-header');
      if (!authorHeader) return;
      var currentUserPublicKey = this.targetPublicKey || this.mod.publicKey;
      var pageUrl = this.mod.returnStackUrl(currentUserPublicKey);
      var safePageUrl = this.app.browser.escapeHTML(pageUrl);

      // Clear header
      authorHeader.innerHTML = '';

      // Create container for author identity (viewing another user)
      var authorIdentityContainer = document.createElement('div');
      authorIdentityContainer.id = 'stack-explore-author-identity';
      authorHeader.appendChild(authorIdentityContainer);

      // Render the target user's identity
      var saitoUser = new SaitoUser(this.app, this.mod, '#stack-explore-author-identity', currentUserPublicKey, "<a class=\"stack-page-link\" href=\"".concat(safePageUrl, "\">").concat(safePageUrl, "</a>") + "<button type=\"button\" class=\"stack-page-link-copy\" aria-label=\"Copy link\" title=\"Copy link\">" + "<i class=\"fa-solid fa-copy\" aria-hidden=\"true\"></i></button>", '' // fourthelem
      );
      saitoUser.render();
      var copyBtn = authorIdentityContainer.querySelector('.stack-page-link-copy');
      if (copyBtn) {
        copyBtn.onclick = /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(e) {
            var icon, _t;
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.p = _context2.n) {
                case 0:
                  e.preventDefault();
                  e.stopPropagation();
                  _context2.p = 1;
                  _context2.n = 2;
                  return navigator.clipboard.writeText(pageUrl);
                case 2:
                  _context2.n = 4;
                  break;
                case 3:
                  _context2.p = 3;
                  _t = _context2.v;
                  console.error('Stack: copy link failed:', _t);
                  return _context2.a(2);
                case 4:
                  icon = copyBtn.querySelector('i');
                  copyBtn.classList.add('is-copied');
                  icon === null || icon === void 0 || icon.classList.replace('fa-copy', 'fa-check');
                  clearTimeout(copyBtn._copiedTimer);
                  copyBtn._copiedTimer = setTimeout(function () {
                    copyBtn.classList.remove('is-copied');
                    icon === null || icon === void 0 || icon.classList.replace('fa-check', 'fa-copy');
                  }, 1200);
                case 5:
                  return _context2.a(2);
              }
            }, _callee2, null, [[1, 3]]);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }();
      }

      // ========================================================================
      // INVARIANT 3: Update action buttons based on filter
      // ========================================================================
      var settingsBtn = document.querySelector('#stack-explore-settings-btn');
      if (settingsBtn) {
        // Temporary since there is no connected functionality
      }

      // ( + ) is "new post" on my own feed and "subscribe" on a creator I don't follow yet.
      // isSubscribed() is true for my own key, so check ownership first.
      var plusBtn = document.querySelector('#stack-explore-plus-btn');
      if (plusBtn) {
        var isOwnFeed = currentUserPublicKey === this.mod.publicKey;
        var canSubscribe = !isOwnFeed && !this.mod.isSubscribed(currentUserPublicKey);
        var label = isOwnFeed ? 'New post' : 'Subscribe';
        plusBtn.classList.toggle('is-hidden', !isOwnFeed && !canSubscribe);
        plusBtn.setAttribute('aria-label', label);
        plusBtn.setAttribute('title', label);
        plusBtn.onclick = function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (isOwnFeed) {
            _this2.startNewPost();
          } else {
            _this2.handleSubscribeToCreator();
          }
        };
      }
    }

    /**
     * Loads posts for the given filter using fetchPostsForAuthor().
     * Shows loading state, then populated or empty state.
     *
     * Remote fetches are throttled per author for two minutes, but only once a fetch
     * has actually reached peers — results gathered before peers connect are partial.
     *
     * @param {string} author - publicKey to load
     * @param {Object} options
     * @param {boolean} options.force - bypass the throttle (explicit refresh)
     */
  }, {
    key: "loadPostsForFilter",
    value: function () {
      var _loadPostsForFilter = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(author) {
        var _ref2,
          _ref2$force,
          force,
          ts,
          fresh,
          _yield$this$mod$fetch,
          posts,
          complete,
          _args3 = arguments;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _ref2 = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {}, _ref2$force = _ref2.force, force = _ref2$force === void 0 ? false : _ref2$force;
              if (author) {
                _context3.n = 1;
                break;
              }
              console.warn('No author resolved for filter:', author);
              return _context3.a(2);
            case 1:
              ts = Date.now();
              fresh = this.lastTimeStamp[author] && ts - this.lastTimeStamp[author] <= 120000;
              if (!(force || !fresh)) {
                _context3.n = 3;
                break;
              }
              this.isLoading = true;
              this.updatePostsGrid(author);
              console.log('fetching', author);
              _context3.n = 2;
              return this.mod.fetchPostsForAuthor(author, {
                forceRemote: true
              });
            case 2:
              _yield$this$mod$fetch = _context3.v;
              posts = _yield$this$mod$fetch.posts;
              complete = _yield$this$mod$fetch.complete;
              this.posts[author] = posts;
              if (complete) {
                this.lastTimeStamp[author] = ts;
              }
              this.awaitingPeers = !complete;
            case 3:
              this.isLoading = false;
              this.updatePostsGrid(author);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function loadPostsForFilter(_x2) {
        return _loadPostsForFilter.apply(this, arguments);
      }
      return loadPostsForFilter;
    }()
    /**
     * Updates the posts grid with current state (loading, empty, or populated).
     */
  }, {
    key: "updatePostsGrid",
    value: function updatePostsGrid() {
      var _this$posts$author,
        _this3 = this;
      var author = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var grid = document.querySelector('#stack-explore-posts-grid');
      if (!grid) {
        return;
      }
      this.pruneEditedPosts();
      var hasPosts = ((_this$posts$author = this.posts[author]) === null || _this$posts$author === void 0 ? void 0 : _this$posts$author.length) > 0;
      if (this.isLoading || this.awaitingPeers && !hasPosts) {
        // PART 5: Show loading spinner with "Fetching latest posts…" message
        grid.innerHTML = "\n        <div class=\"loading\">\n          <div class=\"loading-inner\">\n            <i class=\"fa-solid fa-spinner fa-spin\"></i>\n            <p>".concat(this.awaitingPeers && !this.isLoading ? 'Connecting to the network…' : 'Fetching latest posts…', "</p>\n          </div>\n        </div>\n      ");
      } else if (hasPosts) {
        var teaserHtml = this.posts[author].map(function (transaction) {
          var teaser = new PostTeaser(_this3.app, _this3.mod, '', transaction);
          return teaser.render(); // Returns HTML string for batch rendering
        }).join('');
        grid.innerHTML = teaserHtml;
        // Re-attach click handlers for new posts
        this.attachPostClickHandlers();
      } else {
        if (author == this.mod.publicKey) {
          grid.innerHTML = "\n        <div class=\"empty\">\n          <i class=\"fa-solid fa-newspaper\"></i>\n          <h3>Welcome</h3>\n          <p>\n            You haven't published any posts yet. <span class=\"alt-new-post saito-anchor\">Get started now</span>\n          </p>\n        </div>\n      ";
          this.attachGetStartedHandler();
        } else {
          // Show empty state for reading
          grid.innerHTML = "\n        <div class=\"empty\">\n          <i class=\"fa-solid fa-newspaper\"></i>\n          <h3>No posts available</h3>\n          <p>\n            No posts are visible at this time. This may be because no posts have been published yet, or you may need to subscribe to see content from this creator.\n          </p>\n        </div>\n      ";
        }
      }
    }
  }, {
    key: "pruneEditedPosts",
    value: function pruneEditedPosts() {
      var _this4 = this;
      if (!Array.isArray(this.posts[this.targetPublicKey])) {
        return;
      }
      var hasChildren = new Set();

      // First pass: record all parents that have edits
      var _iterator2 = _createForOfIteratorHelper(this.posts[this.targetPublicKey]),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _tx$returnMessage2, _msg$data4;
          var tx = _step2.value;
          if (!(tx !== null && tx !== void 0 && tx.signature)) {
            continue;
          }
          var msg = (_tx$returnMessage2 = tx.returnMessage) === null || _tx$returnMessage2 === void 0 ? void 0 : _tx$returnMessage2.call(tx);
          if (msg !== null && msg !== void 0 && (_msg$data4 = msg.data) !== null && _msg$data4 !== void 0 && _msg$data4.parent_id) {
            var _msg$data5;
            hasChildren.add(msg === null || msg === void 0 || (_msg$data5 = msg.data) === null || _msg$data5 === void 0 ? void 0 : _msg$data5.parent_id);
          }
        }

        // Second pass: keep only latest leaf nodes
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this.posts[this.targetPublicKey] = this.posts[this.targetPublicKey].filter(function (tx) {
        var _tx$returnMessage, _msg$data$timestamp, _msg$data, _msg$data2;
        if (!(tx !== null && tx !== void 0 && tx.signature)) {
          return false;
        }
        var msg = (_tx$returnMessage = tx.returnMessage) === null || _tx$returnMessage === void 0 ? void 0 : _tx$returnMessage.call(tx);
        var ts = (_msg$data$timestamp = msg === null || msg === void 0 || (_msg$data = msg.data) === null || _msg$data === void 0 ? void 0 : _msg$data.timestamp) !== null && _msg$data$timestamp !== void 0 ? _msg$data$timestamp : 0;

        // Rule 1: remove anything that has been edited
        if (hasChildren.has(tx.signature)) {
          return false;
        }

        // Rule 2: among siblings, keep only newest
        if (msg !== null && msg !== void 0 && (_msg$data2 = msg.data) !== null && _msg$data2 !== void 0 && _msg$data2.parent_id) {
          return !_this4.posts[_this4.targetPublicKey].some(function (other) {
            var _other$returnMessage, _om$data, _msg$data3, _om$data$timestamp, _om$data2;
            if (!(other !== null && other !== void 0 && other.signature)) {
              return false;
            }
            var om = (_other$returnMessage = other.returnMessage) === null || _other$returnMessage === void 0 ? void 0 : _other$returnMessage.call(other);
            return (om === null || om === void 0 || (_om$data = om.data) === null || _om$data === void 0 ? void 0 : _om$data.parent_id) === (msg === null || msg === void 0 || (_msg$data3 = msg.data) === null || _msg$data3 === void 0 ? void 0 : _msg$data3.parent_id) && ((_om$data$timestamp = om === null || om === void 0 || (_om$data2 = om.data) === null || _om$data2 === void 0 ? void 0 : _om$data2.timestamp) !== null && _om$data$timestamp !== void 0 ? _om$data$timestamp : 0) > ts;
          });
        }
        return true;
      });
    }

    /**
     * Attaches click handlers to post teasers.
     * Each teaser should load ViewPost with its transaction.
     * Resolves transactions from cache using signature.
     */
  }, {
    key: "attachPostClickHandlers",
    value: function attachPostClickHandlers() {
      var _this5 = this;
      var teasers = document.querySelectorAll('#stack-explore-posts-grid .post-teaser');
      teasers.forEach(function (teaser) {
        // Get transaction signature from DOM (preferred) or fallback to post-id
        var txSignature = teaser.getAttribute('data-tx-signature') || teaser.getAttribute('data-post-id');
        if (!txSignature) return;

        // Remove existing click handlers to avoid duplicates
        var newTeaser = teaser.cloneNode(true);
        teaser.parentNode.replaceChild(newTeaser, teaser);

        // Attach click handler
        newTeaser.onclick = /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(e) {
            var tx, _t2;
            return _regenerator().w(function (_context4) {
              while (1) switch (_context4.p = _context4.n) {
                case 0:
                  e.preventDefault();
                  e.stopPropagation();

                  // Close the explore overlay
                  _this5.overlay.hide();

                  // Resolve transaction from cache
                  // First try this.posts (already loaded)
                  tx = _this5.posts[_this5.targetPublicKey].find(function (p) {
                    return p.signature === txSignature;
                  }) || null; // If not found, try Stack module cache
                  if (!tx && _this5.mod.transactionCache && _this5.mod.transactionCache[txSignature]) {
                    tx = _this5.mod.transactionCache[txSignature];
                  }

                  // If still not found, try loading via middleware (cache → localhost → peers)
                  if (!(!tx && _this5.mod.loadPost)) {
                    _context4.n = 4;
                    break;
                  }
                  _context4.p = 1;
                  _context4.n = 2;
                  return _this5.mod.loadPost(txSignature, {}, null);
                case 2:
                  tx = _context4.v;
                  _context4.n = 4;
                  break;
                case 3:
                  _context4.p = 3;
                  _t2 = _context4.v;
                  console.debug('Stack: Failed to load transaction:', _t2);
                case 4:
                  // Load ViewPost with transaction (or show error if not found)
                  _this5.loadViewPost(tx, txSignature);
                case 5:
                  return _context4.a(2);
              }
            }, _callee4, null, [[1, 3]]);
          }));
          return function (_x3) {
            return _ref3.apply(this, arguments);
          };
        }();
      });
    }
  }, {
    key: "attachGetStartedHandler",
    value: function attachGetStartedHandler() {
      var _this6 = this;
      Array.from(document.querySelectorAll('.alt-new-post')).forEach(function (btn) {
        btn.onclick = function (e) {
          _this6.startNewPost();
        };
      });
    }
  }, {
    key: "startNewPost",
    value: function startNewPost() {
      document.querySelector('#stack-create-post-btn').click();
      this.overlay.hide();
    }

    /**
     * Loads ViewPost into the main saito-container.
     * Handles missing transactions gracefully with error message.
     *
     * @param {Transaction|null} tx - The transaction to render, or null if not found
     * @param {string} txSignature - The transaction signature (for error messages)
     */
  }, {
    key: "loadViewPost",
    value: function loadViewPost() {
      var _this7 = this;
      var tx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var txSignature = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      // ========================================================================
      // INVARIANT 4: Unmount before navigating to viewer (navigation path: explore → viewer)
      // ========================================================================
      if (this.mod.create_post_ui && typeof this.mod.create_post_ui.onEditorUnmount === 'function') {
        this.mod.create_post_ui.onEditorUnmount();
      }
      var container = document.querySelector('.saito-container');
      if (!container) return;

      // Reset scroll position immediately
      window.scrollTo({
        top: 0,
        behavior: 'instant'
      });
      if (container.scrollTop !== undefined) {
        container.scrollTop = 0;
      }

      // Store current opacity if already set
      var currentOpacity = container.style.opacity || '1';

      // Fade out existing content
      container.style.transition = 'opacity 200ms ease-out';
      container.style.opacity = '0';

      // After fade out, replace content and fade in
      setTimeout(function () {
        // Clear container
        container.innerHTML = '';

        // If transaction is missing, show error message
        if (!tx) {
          var errorHtml = "\n          <div class=\"explore-error\">\n            <i class=\"fa-solid fa-exclamation-circle\"></i>\n            <h2>Post Not Available</h2>\n            <p>\n              This post could not be loaded or is no longer available.\n            </p>\n            ".concat(txSignature ? "\n              <p class=\"sig\">\n                ".concat(txSignature.substring(0, 32), "...\n              </p>\n            ") : '', "\n          </div>\n        ");
          container.innerHTML = errorHtml;
        } else {
          // Create and render ViewPost with the transaction
          // ViewPost renders solely from the provided Transaction
          var viewPost = new ViewPost(_this7.app, _this7.mod, '.saito-container', tx);
          viewPost.render(tx);
        }

        // Fade in new content
        requestAnimationFrame(function () {
          container.style.transition = 'opacity 200ms ease-in';
          container.style.opacity = '0';

          // Trigger reflow, then fade in
          void container.offsetHeight;
          requestAnimationFrame(function () {
            container.style.opacity = '1';

            // Reset scroll position after content is visible
            setTimeout(function () {
              window.scrollTo({
                top: 0,
                behavior: 'instant'
              });
              if (container.scrollTop !== undefined) {
                container.scrollTop = 0;
              }
              // Clean up inline styles after transition completes
              setTimeout(function () {
                container.style.transition = '';
                container.style.opacity = '';
              }, 200);
            }, 50);
          });
        });
      }, 200);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this8 = this;
      try {
        // Update author header on initial load
        this.updateAuthorHeader();

        // Add subscription function -> in help / bottom of the explore list
        var addSubscriptionBtn = document.querySelector('#stack-explore-add-subscription-btn');
        if (addSubscriptionBtn) {
          addSubscriptionBtn.onclick = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this8.handleAddSubscription();
          };
        }

        // Mobile Alternate
        var mobileAddBtn = document.querySelector('.explore .mobile-add');
        if (mobileAddBtn) {
          mobileAddBtn.onclick = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this8.handleAddSubscription();
          };
        }
        var settingsBtn = document.querySelector('#stack-explore-settings-btn');
        if (settingsBtn) {
          settingsBtn.onclick = function (e) {
            siteMessage('Saito Stack is Under Development...', 2000);
          };
        }
        document.querySelectorAll('.explore .filters > .item').forEach(function (item) {
          _this8.bindFilterItem(item);
        });

        // Mobile author selector
        var mobileSelector = document.querySelector('.explore .mobile-selector');
        if (mobileSelector) {
          mobileSelector.onchange = function (e) {
            e.preventDefault;
            var filter = e.currentTarget.value;
            // IMPORTANT: user-driven navigation overrides URL bootstrap
            _this8.targetPublicKey = filter;
            // Update author header based on selection
            _this8.updateAuthorHeader();
            // Load posts for the selected filter
            _this8.loadPostsForFilter(filter);
          };
        }

        // Post teaser clicks are now handled by attachPostClickHandlers()
        // This is called after posts are loaded
        this.attachPostClickHandlers();
      } catch (err) {
        console.error('Explore overlay attachEvents error:', err);
      }
    }

    /**
     * Handle manual subscription addition via "+" icon
     * Opens a modal/overlay to enter username or publicKey
     */
  }, {
    key: "handleAddSubscription",
    value: function () {
      var _handleAddSubscription = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var promptText, input;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return sprompt('Enter Saito username or public key:');
            case 1:
              promptText = _context5.v;
              if (!(!promptText || !promptText.trim())) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2);
            case 2:
              input = promptText.trim();
              this.resolveAndSubscribe(input);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function handleAddSubscription() {
        return _handleAddSubscription.apply(this, arguments);
      }
      return handleAddSubscription;
    }()
    /**
     * Resolve username/publicKey and add subscription
     * @param {string} input - Username or publicKey
     */
  }, {
    key: "resolveAndSubscribe",
    value: function () {
      var _resolveAndSubscribe = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(input) {
        var publicKey, keyData, added, _t3;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              publicKey = input; // Check if input is a valid publicKey
              if (this.app.crypto.isPublicKey(input)) {
                _context6.n = 2;
                break;
              }
              if (!input.includes('@')) {
                input += '@saito';
              }
              // Try to resolve username to publicKey via keychain
              keyData = this.app.keychain.returnKey({
                identifier: input
              });
              if (!(keyData && keyData.publicKey)) {
                _context6.n = 1;
                break;
              }
              publicKey = keyData.publicKey;
              _context6.n = 2;
              break;
            case 1:
              siteMessage("Unable to find ".concat(input, ", Please check and try again"), 5000);
              return _context6.a(2);
            case 2:
              if (this.app.crypto.isPublicKey(publicKey)) {
                _context6.n = 3;
                break;
              }
              siteMessage('Invalid public key. Please check and try again', 5000);
              return _context6.a(2);
            case 3:
              // Add subscription
              added = this.mod.addSubscription(publicKey);
              if (added) {
                // Refresh the overlay to show new subscription
                this.mod.exploreOverlay.render();
              } else {
                siteMessage('Already subscribed to this creator.', 5000);
              }
              _context6.n = 5;
              break;
            case 4:
              _context6.p = 4;
              _t3 = _context6.v;
              console.error('Stack: Error adding subscription:', _t3);
              siteMessage('Error adding subscription. Please try again.', 5000);
            case 5:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 4]]);
      }));
      function resolveAndSubscribe(_x4) {
        return _resolveAndSubscribe.apply(this, arguments);
      }
      return resolveAndSubscribe;
    }()
  }, {
    key: "bindFilterItem",
    value: function bindFilterItem(item) {
      var _this9 = this;
      item.onclick = function (e) {
        e.preventDefault();
        document.querySelectorAll('.explore .filters > .item').forEach(function (entry) {
          entry.classList.remove('active');
        });
        item.classList.add('active');
        var filter = item.getAttribute('data-filter');
        _this9.targetPublicKey = filter;
        var mobileSelector = document.querySelector('.explore .mobile-selector');
        if (mobileSelector) {
          mobileSelector.value = filter;
        }
        _this9.updateAuthorHeader();
        _this9.loadPostsForFilter(filter);
      };
    }
  }, {
    key: "addCreatorToSidebar",
    value: function addCreatorToSidebar(publicKey) {
      var filters = document.querySelector('.explore .filters');
      if (filters && !filters.querySelector(".item[data-filter=\"".concat(publicKey, "\"]"))) {
        var item = document.createElement('div');
        item.className = 'item' + (this.targetPublicKey === publicKey ? ' active' : '');
        item.dataset.filter = publicKey;
        var address = this.isAddressLabel(publicKey) ? " class=\"saito-address\" data-id=\"".concat(publicKey, "\" data-disable=\"true\"") : '';
        item.innerHTML = "<i class=\"fa-solid fa-user\"></i><span".concat(address, ">").concat(this.app.browser.escapeHTML(this.createLabel(publicKey)), "</span>");
        filters.appendChild(item);
        this.bindFilterItem(item);
      }
      var mobileSelector = document.querySelector('.explore .mobile-selector');
      if (mobileSelector && !mobileSelector.querySelector("option[value=\"".concat(publicKey, "\"]"))) {
        var option = document.createElement('option');
        option.value = publicKey;
        option.textContent = this.createLabel(publicKey);
        if (this.targetPublicKey === publicKey) {
          option.selected = true;
        }
        mobileSelector.appendChild(option);
      }
      this.updateHelpNoteVisibility();
    }

    /**
     * Handle contextual subscription (when viewing creator via URL)
     * Adds the targetPublicKey to subscriptions
     */
  }, {
    key: "handleSubscribeToCreator",
    value: function handleSubscribeToCreator() {
      if (!this.targetPublicKey) {
        return;
      }
      var added = this.mod.addSubscription(this.targetPublicKey);
      if (added) {
        this.updateAuthorHeader();
        this.addCreatorToSidebar(this.targetPublicKey);
        siteMessage('Subscribed!', 2000);
      }
    }
  }]);
}();
module.exports = ExploreOverlay;